<template>
  <div class="modal fade confirm" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">編輯財務狀況<span class="modal-title text-red ml-3">(我已確實取得客戶同意，為客戶進行資料建檔！)</span></h3>
        </div>
        <div class="modal-body">
          <form class="form">
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">家庭年收入</label>
              <div class="col-9">
                <select class="form-control form-control-inline form-wide" v-model="form.household_income">
                  <option value="">請選擇</option>
                  <option
                  v-for="(c, cid) in householdOpt"
                  :key="`household-item-${cid}`"
                  :value="c.val">{{c.text}}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="birth-year" class="col-3 text-right">房貸金額</label>
              <div class="col-9">
                <input type="tel"
                  maxlength="10"
                class="form-control form-control-inline form-short" v-model="form.houseloan">
                <span class="text">萬</span>
              </div>
            </div>
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">個人年所得</label>
              <div class="col-9">
                <select class="form-control form-control-inline form-wide" v-model="form.personal_income">
                  <option value="">請選擇</option>
                  <option
                  v-for="(c, cid) in personalOpt"
                  :key="`city-item-${cid}`"
                  :value="c.val">{{c.text}}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">住屋狀況</label>
              <div class="col-9">
                <select class="form-control form-control-inline form-wide" v-model="form.housing">
                  <option value="">請選擇</option>
                  <option
                  v-for="(c, cid) in housingOpt"
                  :key="`housing-item-${cid}`"
                  :value="c.val">{{c.text}}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">月平均投資</label>
              <div class="col-9">
                <select class="form-control form-control-inline form-wide" v-model="form.monthly_invest">
                  <option value="">請選擇</option>
                  <option
                  v-for="(c, cid) in investOpt"
                  :key="`invest-item-${cid}`"
                  :value="c.val">{{c.text}}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">交通工具</label>
              <div class="col-9">
                <select class="form-control form-control-inline form-wide"
                v-model="form.vehicle">
                  <option value="">請選擇</option>
                  <option
                  v-for="(e, eid) in vehicleOpt"
                  :key="`vehicle-item-${eid}`"
                  :value="e.val">{{e.text}}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">理財工具</label>
              <div class="col-9">
                <div class="checkbox checkbox-inline"
                v-for="(tool, tid) in tools"
                :key="`tool-item-${tid}`">
                  <input type="checkbox"
                  v-model="form.finance_tool"
                  :id="`tool-item-${tid}`"
                  :value="tool.val">
                  <label :for="`tool-item-${tid}`">{{tool.text}}</label>
                </div>
              </div>
            </div>

            <div class="action text-right">
              <a @click="$emit('close')" class="btn btn-default">
                取消
              </a>
              <a @click.stop.prevent="submit()" class="btn btn-primary">
                儲存
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SocailDataModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    inputs: {
      type: Object,
      default: null
    }
  },
  watch: {
    'open': 'transformToEnum',
    'form.houseloan':function(){
      this.form.houseloan = this.form.houseloan.replace(/[^\d]/g,'');
    }, 
  },
  computed: {

  },
  data () {
    return {
      householdOpt: [
        {text:'60萬以下', val: '1'},
        {text:'61萬~80萬', val: '2'},
        {text:'81萬~100萬', val: '3'},
        {text:'101萬~150萬', val: '4'},
        {text:'151萬~200萬', val: '5'},
        {text:'201萬~350萬', val: '6'},
        {text:'351萬以上', val: '7'}
      ],
      personalOpt: [
        {text:'無', val: '1'},
        {text:'30萬以下', val: '2'},
        {text:'31~60萬', val: '3'},
        {text:'61~100萬', val: '4'},
        {text:'101~200萬', val: '5'},
        {text:'201萬以上', val: '6'}
      ],
      housingOpt: [
        {text:'自有', val: '1'},
        {text:'租賃', val: '2'},
        {text:'其他親屬所有', val: '3'},
        {text:'其他', val: '4'},
      ],
      investOpt: [
        {text:'無', val: '1'},
        {text:'3千以下', val: '2'},
        {text:'3千~5千', val: '3'},
        {text:'5千~1萬', val: '4'},
        {text:'1萬~2萬', val: '5'},
        {text:'2萬~5萬', val: '6'},
        {text:'5萬以上', val: '7'}
      ],
      vehicleOpt: [
        {text:'無', val: '1'},
        {text:'機車', val: '2'},
        {text:'汽車', val: '3'},
        {text:'機車與汽車', val: '4'}
      ],
      tools: [
        {text:'定存', val: '1'},
        {text:'保險', val: '2'},
        {text:'共同基金', val: '3'},
        {text:'標會', val: '4'},
        {text:'債券', val: '5'},
        {text:'股票', val: '6'},
        {text:'期貨外匯', val: '7'},
        {text:'不動產', val: '8'},
        {text:'其他', val: '9'}
      ],
      form: {
        personal_income : '',
        household_income : '',
        houseloan : '',
        housing : '',
        monthly_invest : '',
        finance_tool : [],
        vehicle : ''
      }
      // form: {
      //   personal_income: !this.inputs ? 0 : this.inputs.personal_income,
      //   household_income: !this.inputs ? 0 : this.inputs.household_income,
      //   houseloan: !this.inputs ? 0 : this.inputs.houseloan,
      //   housing: !this.inputs ? 0 : this.inputs.housing,
      //   monthly_invest: !this.inputs ? 0 : this.inputs.monthly_invest,
      //   finance_tool: !this.inputs ? 0 : this.inputs.finance_tool.split(/、/g),
      //   vehicle: !this.inputs ? 0 : this.inputs.vehicle
      // }
    }
  },
  methods: {
    checkWordLimit(){ // 檢查欄位字數
      if(this.form.houseloan.length > 10){
        return true 
      }else{
        return false
      }
    },
    submit () {
      if(this.checkWordLimit()){    // 檢查欄位字數
        return this.$toast.info({title: '欄位字數超過限制'})
      }
      
      this.$emit('submit', this.form)
    },
    transformToEnum() {
      
      this.form.personal_income = this.inputs.personal_income ? this.personalOpt.filter(item => item.text == this.inputs.personal_income)[0].val : ''
      this.form.household_income = this.inputs.household_income ? this.householdOpt.filter(item => item.text == this.inputs.household_income)[0].val : ''
      this.form.houseloan = this.inputs.houseloan + ''
      this.form.housing = this.inputs.housing ? this.housingOpt.filter(item => item.text == this.inputs.housing)[0].val : ''
      this.form.monthly_invest = this.inputs.monthly_invest ? this.investOpt.filter(item => item.text == this.inputs.monthly_invest)[0].val : ''
      let toolSet = new Set(this.inputs.finance_tool.split(',').map(item => item.trim()))
      this.form.finance_tool = this.tools.filter(item => toolSet.has(item.text)).map(item => item.val)
      this.form.vehicle = this.inputs.vehicle ? this.vehicleOpt.filter(item => item.text == this.inputs.vehicle)[0].val : ''
      
    }
  },
  mounted () {
  }
}
</script>
